angular.module("exportExcelLinkAdv.components", [])
    .component("exportExcelLinkAdv", {
        templateUrl: "ng/components/exportExcelLinkAdv/exportExcelLinkAdv.view.html",
        bindings: {},
        controller: ExportExcelLinkAdvController,
        controllerAs: "exportExcelLinkAdvCtrl"
    })

function ExportExcelLinkAdvController($uniService) {

    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            dataInserimentoDa: null,
            dataInserimentoA: null,
            emailRitorno: null
        }
    }

    self.exportAdv = function () {
        self.loading = true;
        $uniService.exportAdv(self.supportModel)
            .then(function (response) {
                console.log("Esportazione ADV completata con successo");
            })
            .catch(function (error) {
                console.error("Errore durante l'esportazione ADV:", error);
            })
            .finally(function () {
                self.loading = false;
            });
    };

}